import IRouterLink from "@/interfaces/IRouterLink";
import ITableCol from "@/interfaces/ITableCol";
import cloneObject from "@/libs/cloneObject";
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

import CardHeader from '@/components/Includes/CardHeader/CardHeader.vue';
import SelectionColumnsInTable from '@/components/Includes/SelectionColumnsInTable/SelectionColumnsInTable.vue';
import IMultiSelectItem from '@/interfaces/selects/IMultiSelectItem';
import ISelectItemDefault from '@/interfaces/selects/ISelectItemDefault';

@Component({
    name: 'DefaultTools',
    components: {
        SelectionColumnsInTable,
        CardHeader
    }
})
export default class DefaultTools extends Vue {
    @Prop(Boolean)
    backBtn!: boolean;

    @Prop({type: String, default: 'text'}) private readonly inputType!: string;
    @Prop({type: String, default: 'Enter query'}) private readonly inputPlaceholder!: string;
    // Begin Prop for CardHeader
    @Prop(Boolean)
    private button!: boolean;

    @Prop(String)
    private buttonColor!: string;

    @Prop(String)
    private buttonTitle!: string;

    @Prop(String)
    private buttonText!: string;

    @Prop(String)
    private buttonIcon!: string;

    @Prop(Function)
    private buttonEvent!: any;

    @Prop(Boolean)
    private buttonDisabled!: boolean;

    @Prop(Object)
    private routerLink?: IRouterLink;
    // End Prop for CardHeader

    @Prop(Boolean)
    private searchByItems!: boolean;

    @Prop(String)
    private buttonAccessLevel!: string;

    @Prop(Boolean)
    private limit!: boolean;

    @Prop(Array)
    private tableColumns!: any;

    @Prop(String)
    private searchByName!: string;

    @Prop(String) private currentLimit?: string;

    private filter: string = '';

    private selectedTableColumns: IMultiSelectItem[] = [];

    private selectedLimit: string = this.currentLimit ? this.currentLimit:'100';

    private limits: ISelectItemDefault[] = [
        {value: '100', text: '100'},
        {value: '250', text: '250'},
        {value: '500', text: '500'}
    ];

    private get searchFieldName(): string {
        return this.searchByName ? this.searchByName : 'item'
    }

    private cleareFilter() {
        this.filter = ''
    }

    @Watch('selectedTableColumns')
    private changedTableColumns(columnsList: IMultiSelectItem[]) {
        this.selectedTableColumns = columnsList;
        this.$emit('selectedTableColumns', columnsList);
    }

    @Watch('filter')
    private search() {
        this.$emit('filtered', this.filter);
    }

    @Watch('selectedLimit')
    private changeLimit() {
        this.$emit('limit', this.selectedLimit);
    }
}
